import { getTiersForUser, formatCurrency, type Country, type Currency } from '@skin-seoul/service';

/**
 * Returns the authenticated-user milestone banner message based on cart total and BMSM tiers.
 * Tiers for registered users: [Free Shipping, 5% OFF, 10% OFF].
 
 * Bold markers (**text**) are used to indicate semibold text — use parseMessageWithBold()
 * to render them.
 */
export function getAuthenticatedMilestoneBannerMessage(params: {
  cartTotalPrice: number;
  country: Country;
  currency: Currency;
  isFirstOrder: boolean;
}): string | null {
  const { cartTotalPrice, country, currency, isFirstOrder } = params;
  const tiers = getTiersForUser({ country, isAuthenticated: true, isFirstOrder });

  if (tiers.length < 2) {
    return null;
  }

  const [firstTier, secondTier, thirdTier] = tiers;

  // Below first milestone (Free Shipping): logged-in users already have free shipping,
  // so guide them toward the next milestone (5% off)  // Reached first milestone (Free Shipping): add $X more to unlock 5% off
  if (cartTotalPrice < firstTier.threshold || cartTotalPrice < secondTier.threshold) {
    const amountNeeded = secondTier.threshold - cartTotalPrice;
    const formatted = formatCurrency(currency, amountNeeded);
    return `Add ${formatted} more to unlock **5% off**.`;
  }

  // Reached 5% OFF: guide toward 10% off
  if (thirdTier && cartTotalPrice < thirdTier.threshold) {
    const amountNeeded = thirdTier.threshold - cartTotalPrice;
    const formatted = formatCurrency(currency, amountNeeded);
    return `You're getting **5% off** — **add ${formatted}** more for **10% off**!`;
  }

  // Reached 10% OFF
  return '**10% off** unlocked — plus **free shipping** on top!';
}
